import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { RecipeOriginType } from '../../../enums/RecipeOriginType';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { SaveRecipeInput } from '../../../models/SaveRecipeInput';

export class CreateCustomerRecipeService extends HttpServiceBase {

  handle = (input: CreateCustomerRecipeServiceInput): Promise<Result<CreateCustomerRecipeServiceOutput> | null> => {
    const promise = this.http.post<Result<CreateCustomerRecipeServiceOutput>, CreateCustomerRecipeServiceInput>(
        `${this.baseUrlSislogApi}/point-of-sale/customer-recipe?apiKey=${this.getSislogApiKey()}`,
        input);
    return promise;
  }
}

export class CreateCustomerRecipeServiceInput extends SaveRecipeInput {
  name?: string|null;
  description?: string;
  createdAt: string;
  approvedAt?: string|null;
  origin: RecipeOriginType;
  relatedZerezesCustomerRecipeId?: number|null;
  customerRecipeId?: number|null;
}

export class CreateCustomerRecipeServiceOutput {
  result?: boolean | null;
  customerRecipe?: CustomerRecipe | null;
}